module.exports = __webpack_public_path__ + "img/logo-all.84989e5a.png";